// extracted by mini-css-extract-plugin
export default {"grouped-select-filters":"ManageProducts_grouped-select-filters__kwoec"};